import clearBodyPointerEventsLock from './clearBodyPointerEventsLock';
import type { ScheduleClearBodyPointerEventsLocksParams } from '../types';

const scheduleClearBodyPointerEventsLocks = ({
    reason,
}: ScheduleClearBodyPointerEventsLocksParams): void => {
    clearBodyPointerEventsLock({ reason });
    window.setTimeout(() => {
        clearBodyPointerEventsLock({ reason: `${reason}-timeout-0` });
    }, 0);
    window.setTimeout(() => {
        clearBodyPointerEventsLock({ reason: `${reason}-timeout-350` });
    }, 350);
};

export default scheduleClearBodyPointerEventsLocks;
